import { NodeInterface } from "@swivl-mono/types";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";

const Media = {
  Type: "media",
  Empty: function () {
    return {
      "id": RandomId(6),
      "type": Media.Type,
      "mediaUrl": "",
      "mediaType": "image",
      "delay": 0,
      "showTyping": true,
      "onCompleteGoto": null
    }
  },

  PlumbData: function (node: NodeInterface) {
    let data: any = {
      node: node,
      label: "Media",
      baseWidth: 160,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto, }]
    };
    if (node.mediaType === "image") {
      data.imageURL = node.mediaUrl;
    } else {
      data.title = node.mediaUrl;
    }
    return TabNodeLayoutData(data);

  },

  InspectorPanel: class MediaInspectorPanel extends NodePanel {


    render() {

      return (<div>
        <div className="panel media_panel">
          <InspectorNodeHeader title="Media" />
          <DelayComponent node={this.props.node} onChange={this.onChange} />
          <div className="commandTitle">MEDIA URL</div>
          <input className="commandInput" name="mediaUrl" value={this.props.node.mediaUrl} onChange={this.onChangeUpdateAndRedraw} />
          <form className="mediaTypeForm">
            <div className="mediaItem">
              <label className="inspectorLabel">
                <input type="radio" value="image" onChange={this.onChange} checked={this.props.node.mediaType === 'image'} name="mediaType" />
                <span className="radioText">Image</span>
              </label>
            </div>
            <div className="mediaItem">
              <label className="inspectorLabel">
                <input type="radio" value="video" onChange={this.onChange} checked={this.props.node.mediaType === 'video'} name="mediaType" />
                <span className="radioText">Video</span>
              </label>
            </div>
          </form>
        </div>
        <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
      </div>);
    }
  }
}

export default Media;
